import { failureActionHandler, requestActionHandler } from 'store';
import injectReducer from 'store/injectReducer';
import * as types from 'modules/admin-panel/pages/results/ActionTypes';
import {
	IComment,
	ICommentReducer,
	ICommentsAverage,
	IComparedComment,
	IScaleRange,
	IResponseComment,
} from 'modules/admin-panel/pages/results/models';
import { COMMENT_TYPES } from 'modules/admin-panel/utils';

export const InitialCommentsReducer: ICommentReducer = {
	activeCommentType: COMMENT_TYPES.all,
	totalMarksForEmployer: null,
	error: undefined,
	isLoading: false,
	comment: null,
	marksForEmployer: [],
	commentMarkersAverage: null,
	comparedComments: [],
	rounds: [],
};

export default injectReducer(InitialCommentsReducer, {
	[types.GET_COMMENT.REQUEST]: requestActionHandler,
	[types.GET_COMMENT_AVERAGE.REQUEST]: requestActionHandler,
	[types.GET_MARKS_FOR_EMPLOYER.REQUEST]: requestActionHandler,
	[types.GET_ALL_RELATED_COMMENTS.REQUEST]: requestActionHandler,
	[types.GET_COMPARE_COMMENTS.REQUEST]: requestActionHandler,
	[types.GET_ALL_COMMENTS_DATA.REQUEST]: (
		state: ICommentReducer,
	): ICommentReducer => ({
		...state,
		isLoadingAll: true,
	}),

	[types.GET_COMMENT.FAILURE]: failureActionHandler,
	[types.GET_COMMENT_AVERAGE.FAILURE]: failureActionHandler,
	[types.GET_MARKS_FOR_EMPLOYER.FAILURE]: failureActionHandler,
	[types.GET_ALL_RELATED_COMMENTS.FAILURE]: failureActionHandler,
	[types.GET_COMPARE_COMMENTS.FAILURE]: failureActionHandler,
	[types.GET_ALL_COMMENTS_DATA.FAILURE]: (
		state: ICommentReducer,
		{ payload }: { payload: Error },
	): ICommentReducer => ({
		...state,
		error: payload,
		isLoadingAll: false,
	}),

	[types.GET_ALL_COMMENTS_DATA.SUCCESS]: (
		state: ICommentReducer,
		{ payload }: { payload: { scaleRange?: IScaleRange } },
	): ICommentReducer => ({
		...state,
		...payload,
		error: undefined,
		isLoadingAll: false,
	}),

	[types.GET_COMMENT.SUCCESS]: (
		state: ICommentReducer,
		{ payload }: { payload: IComment },
	): ICommentReducer => ({
		...state,
		comment: payload,
		error: undefined,
		isLoading: false,
	}),
	[types.GET_COMMENT_AVERAGE.SUCCESS]: (
		state: ICommentReducer,
		{ payload }: { payload: ICommentsAverage },
	): ICommentReducer => ({
		...state,
		commentMarkersAverage: payload,
		error: undefined,
		isLoading: false,
	}),
	[types.GET_MARKS_FOR_EMPLOYER.SUCCESS]: (
		state: ICommentReducer,
		{ payload }: { payload: IResponseComment },
	): ICommentReducer => ({
		...state,
		marksForEmployer: state.marksForEmployer.concat(payload.content),
		totalMarksForEmployer: payload.totalElements,
		error: undefined,
		isLoading: false,
	}),
	[types.RESET_MARKS_FOR_EMPLOYER]: (
		state: ICommentReducer,
	): ICommentReducer => ({
		...state,
		marksForEmployer: [],
	}),
	[types.GET_ALL_RELATED_COMMENTS.SUCCESS]: (
		state: ICommentReducer,
		{ payload }: { payload: IResponseComment },
	): ICommentReducer => ({
		...state,
		relatedComments: payload,
		error: undefined,
		isLoading: false,
	}),

	[types.SET_COMMENTS_COMMENT_TYPE]: (
		state: ICommentReducer,
		{ payload }: { payload: string },
	): ICommentReducer => ({
		...state,
		activeCommentType: payload,
	}),

	[types.RESET_COMMENTS_TYPE]: (state: ICommentReducer): ICommentReducer => ({
		...state,
		activeCommentType: COMMENT_TYPES.all,
	}),

	[types.RESET_COMPARED_COMMENTS]: (
		state: ICommentReducer,
	): ICommentReducer => ({
		...state,
		comparedComments: [],
	}),

	[types.GET_COMPARE_COMMENTS.SUCCESS]: (
		state: ICommentReducer,
		{ payload }: { payload: IComparedComment[] },
	): ICommentReducer => ({
		...state,
		comparedComments: payload,
		error: undefined,
		isLoading: false,
	}),

	[types.RESET_COMMENT_LIST]: (state: ICommentReducer): ICommentReducer => ({
		...state,
		relatedComments: undefined,
	}),
});
